import type { Article, ArticlePreview } from 'interfaces/content/articles/Articles';
import SidebarContentPreviewArticle from 'components/SidebarContentPreview/SidebarContentPreviewItem/SidebarContentPreviewArticle';
import type { Video } from 'interfaces/content/Media';
import SidebarContentPreviewVideo from 'components/SidebarContentPreview/SidebarContentPreviewItem/SidebarContentPreviewVideo';
import { Microsites } from 'constants/constants';
import toKebabCase from 'lodash/kebabCase';
import { COMMON_TEST_IDS } from 'constants/testsIds/common';
import { Wrapper, List, Title } from './SidebarContentPreviewStyles';

export interface SidebarContentPreviewProps {
  title: string;
  contentPlacementCD: string;
  type?: 'article' | 'video';
  items: ArticlePreview[] | Video[];
  parent?: Article;
  className?: string;
  isMobileVisible?: boolean;
}

const SidebarContentPreview = ({
  title,
  contentPlacementCD,
  type = 'article',
  items,
  parent,
  className = '',
  isMobileVisible = true,
}: SidebarContentPreviewProps) => {
  if (items.length === 0) {
    return null;
  }

  const isCryptoOrWell = Microsites.Crypto === parent?.platformCD || Microsites.Well === parent?.platformCD;
  const isNewslettersOrFeaturesSection =
    parent?.primarySection.name === 'Newsletters' || parent?.primarySection.name === 'Features';

  return (
    <Wrapper
      className={`sidebar-content-preview ${className}`}
      $isMobileVisible={isMobileVisible}
      data-cy={`${toKebabCase(title)}-rr`}
    >
      {/*
        Heading component need the right-rail classname in order to insert Nativo ads.
        It needs the CSS selector [right-rail + ul > li:nth-of-type(2)]
      */}
      <Title
        data-cy={COMMON_TEST_IDS.SIDEBAR_CONTENT_PREVIEW}
        className='right-rail'
        as='h3'
        $fontFamily='saol'
        $size={{ default: 'level2' }}
      >
        {!isNewslettersOrFeaturesSection && !isCryptoOrWell && parent && title === 'Most Popular'
          ? `Most popular ${items[0].eyebrowSectionLabel} articles`
          : title}
      </Title>
      <List>
        {type === 'article'
          ? items.map((entry) => (
              <SidebarContentPreviewArticle
                key={(entry as ArticlePreview).title}
                title={title}
                entry={entry as ArticlePreview}
                contentPlacementCD={contentPlacementCD}
                parent={parent}
              />
            ))
          : items.map((entry) => (
              <SidebarContentPreviewVideo
                entry={entry as Video}
                contentPlacementCD={contentPlacementCD}
                key={(entry as Video).name}
              />
            ))}
      </List>
    </Wrapper>
  );
};

export default SidebarContentPreview;
